import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineManualTransmissionIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M18 6c-.5523 0-1 .4477-1 1v4h-4V7c0-.5523-.4477-1-1-1s-1 .4477-1 1v4H7V7c0-.5523-.4477-1-1-1s-1 .4477-1 1v5c0 .5523.4477 1 1 1h5v4c0 .5523.4477 1 1 1s1-.4477 1-1v-4h4v4c0 .5523.4477 1 1 1s1-.4477 1-1V7c0-.5523-.4477-1-1-1Z" clipRule="evenodd"/>
    <path fill="currentColor" d="M4 6c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2ZM10 6c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2ZM10 18c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2ZM16 6c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2ZM16 18c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2Z"/>
  </SvgIcon>
}

export default LineManualTransmissionIcon
